/**
 * The session-wide dictionary cache behind the live preview. Lookups go
 * through the API layer (`dict:check`), so they work identically against the
 * real server and the DEV mock backend.
 */
import { dictCheck } from '../net/api';
import { DictCache } from './preview';

export const dictCache = new DictCache(async (words) => {
  const res = await dictCheck(words);
  return res.ok ? res.results : null;
});
